// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateChileanAddress(addressValue: string): ?UserInputValidationError {
  return addressValue ? VALID : { id: 'empty' };
}
